// components/MarkdownRenderer.tsx
import React from 'react';
import ReactMarkdown from 'react-markdown';
import { ComponentProps } from 'react';

interface MarkdownRendererProps {
  content: string;
  classname?:string
}

const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ content,classname }) => {
  const components = {
    a: ({ href, children }: ComponentProps<'a'>) => (
      <a className='text-primary-light border-b decoration-dashed mx-1' href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    ),
  };

  return <ReactMarkdown className={classname} components={components}>{content}</ReactMarkdown>;
};

export default MarkdownRenderer;
